import { Menu as MuiMenu, MenuItem as MuiMenuItem, styled } from '@mui/material'

export const MenuItem = styled(MuiMenuItem)`
  min-width: ${({ theme }) => theme.spacing(27.5)};
`

export const Menu = styled(MuiMenu)`
  & .MuiPaper-root {
    margin-top: ${({ theme }) => theme.spacing(1)};
  }
`
